// src/pages/packages/Packages.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import PackagesTable from "../../components/packages/PackagesTable";

const Packages = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <PackagesTable />
        </WrapperSection>
    );
};

export default Packages;
